import { useEffect, useRef, useState } from 'react'
import ChatMessageCard from './ChatMessageCard'
import { GoDotFill } from 'react-icons/go'
import { IoMdSend } from 'react-icons/io'
import { TextareaAutosize } from '@mui/material'
import defaultImg from "../../../assets/images/default_profile_img.png"
import { MdArrowBack } from 'react-icons/md'
import { useLocation, useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { NotificationAPI } from '../../../api/NotificationAPI'
import { chatActions } from '../../../redux/reducer/chatReducer'
import { stompClientService } from '../../../util/stompClientService'
import ChatLoader from './ChatLoader'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ChatMessageType, ChatType, shouldFetchUnreadForChat } from '../../../util/ChatUtils.js'
import { rootAction } from '../../../redux/reducer/rootReducer.js'

const ChatBody = () => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const { allChatMessage, totalUnreadMessage, currentChat } = useSelector((store) => store.chat);
    const { chatId } = useParams();
    let isFullScreen = window.innerWidth < 800;
    const { state } = useLocation();
    const chat = state?.currentChat || currentChat;
    const [message, setMessage] = useState('');
    const endRef = useRef(null);
    const scrollContainerRef = useRef(null);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [chatStatus, setChatStatus] = useState({});
    const [memberNamesInShort, setMemberNamesInShort] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [pageDetails, setPageDetails] = useState({ size: 40, number: 0 });
    const [unReadMsgIds, setUnReadMsgIds] = useState([]);

    const sendMessage = () => {
         if(message?.trim()?.length > 20000){
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: 'Maximum 20000 characters allowed' }));
            return;
        }
        if (stompClientService.isConnected()) {
            try {
                stompClientService.getClient().publish({
                    destination: '/app/chat.private',
                    body: JSON.stringify({
                        senderId: userInfo.userId,
                        receiverId: chat.privateChatUserId,
                        chatId: chat.chatId,
                        messageType: ChatMessageType.TEXT,
                        content: message?.trim(),
                        clubId: selectedClub.clubId
                    })
                })
                setMessage('');
            } catch (error) {
                console.error(error);

            }
        } else {
            console.error("Not connected to WebSocket!");
        }
    };

    const sendGroupMessage = () => {
         if(message?.trim()?.length > 20000){
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: 'Maximum 20000 characters allowed' }));
            return;
        }
        if (stompClientService.isConnected()) {
            try {
                stompClientService.getClient().publish({
                    destination: '/app/chat.group',
                    body: JSON.stringify({
                        senderId: userInfo.userId,
                        senderFirstName: userInfo?.firstName ?? '',
                        senderLastName: userInfo?.lastName ?? '', 
                        senderProfileImg: userInfo?.profileImage ?? '', 
                        chatId: chat.chatId,
                        messageType: ChatMessageType.TEXT,
                        content: message?.trim(),
                        clubId: selectedClub.clubId
                    })
                })
                setMessage('');
            } catch (error) {
                console.error(error);

            }
        } else {
            console.error("Not connected to WebSocket!");
        }
    };
    const sendAckForMessageIsSeen = (ids,msg) => {
        if(ids.length === 0) return;
        if (stompClientService.isConnected()) {
            try {
                stompClientService.getClient().publish({
                    destination: '/app/ack/seen',
                    body: JSON.stringify({
                        chatMessageIds:ids,
                        receiverId: userInfo.userId,
                        senderId: msg?.senderId,
                        messageStatus: 'SEEN',
                        seenTime: Date.now(),
                        clubId: selectedClub.clubId
                    })
                });
                dispatch(chatActions.setTotalUnReadMessage(Number(totalUnreadMessage) - Number(ids.length??0)))
            } catch (error) {
                console.error(error);

            }
        } else {
            console.error("Not connected to WebSocket!");
        }
    };
    const findAllMessage = async () => {
        try {
            setIsLoading(true);
            const response = await NotificationAPI.getMessageByUser(
                chatId,userInfo.userId,null,null,pageDetails.size);
            dispatch(chatActions.setAllChatMessage(response.Data));
            if (response.Data.length === 0) {
                setHasMore(false);
            }
        } catch (error) {
            console.error(error);

        } finally {
            setIsLoading(false);
        }
    }
    const findUserChatStatus = async () => {
        try {
            const response = await NotificationAPI.getUserChatStatus(chat.privateChatUserId);
            setChatStatus(response?.Data);
        } catch (error) {
            console.log(error);
        }
    };
    const findFewGroupMemberNames = async () => {
        try {
            const response = await NotificationAPI.getFewChatGroupMemberNames(chatId);
            setMemberNamesInShort(response.Data);
        } catch (error) {
            console.log(error);
        }
    };
    
    // ✅ FIXED: Clean chatId before sending
    const findAllUnreadMessageId = async () => {
        try {
            if (!shouldFetchUnreadForChat(chatId)) {
                return;
            }

            const data = {
                'clubId': selectedClub.clubId,
                'userId': userInfo.userId,
                'chatId': chatId
            };

            const response = await NotificationAPI.getAllUnreadMessageId(data);
            setUnReadMsgIds(response.Data);
            sendAckForMessageIsSeen(response.Data, {});
        } catch (error) {
            console.log(error);
        }
    };
    
    const sendMessageOnEnterPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (chat.chatType == ChatType.GROUP) {
                sendGroupMessage()
            } else {
                sendMessage()
            }
        }
    };
    const scrollToBottom = () => {

        const container = scrollContainerRef.current;
        if (container) {
            container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
            container.scrollTop = container.scrollHeight;
        }
    };


    useEffect(() => {
        requestAnimationFrame(() => {
            scrollToBottom();
        })
    }, [allChatMessage, isLoading]);

    useEffect(() => {
        //console.log('user effect is called');
        if(selectedClub.clubId){
            findAllUnreadMessageId();
        }
    }, [selectedClub.clubId,chatId]);

    useEffect(() => {
        setPageDetails({ size: 40, number: 0 });
        setHasMore(true);
    }, [chatId])

    useEffect(() => {
        dispatch(chatActions.setAllChatMessage([]));
        if (chatId !== 'null' && chat) {
            if (chat.chatType == ChatType.PRIVATE) {
                findUserChatStatus();
            }
            if (chat.chatType == ChatType.GROUP) {
                findFewGroupMemberNames();
            }
            findAllMessage();
        }
    }, [chatId])
    if (isLoading || !chat) {
        return <ChatLoader />
    }
    function formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();

        const isSameDay = (d1, d2) =>
            d1.getDate() === d2.getDate() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getFullYear() === d2.getFullYear();

        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);

        const options = { hour: 'numeric', minute: '2-digit', hour12: true };
        const timeString = date.toLocaleTimeString(undefined, options);

        if (isSameDay(date, now)) {
            return `Today at ${timeString}`;
        } else if (isSameDay(date, yesterday)) {
            return `Yesterday at ${timeString}`;
        } else {
            const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
            const dateString = date.toLocaleDateString(undefined, dateOptions);
            return `${dateString} at ${timeString}`;
        }
    }

    const fetchMoreMesssage = async () => {
        const nextPage = pageDetails.number + 1;
        setPageDetails(prev => ({ ...prev, number: nextPage }));
        try {
            const createdAt = allChatMessage.at(-1).createdAt;
            const chatMessageId = allChatMessage.at(-1).chatMessageId;
            const response = await NotificationAPI.getMessageByUser(
                chat.chatId,userInfo.userId,createdAt,chatMessageId, pageDetails.size);
            dispatch(chatActions.setAllChatMessageKeepOldMessage(response.Data));
            if (response.Data.length === 0) {
                setHasMore(false);
            }
        } catch (error) {
            console.log(error);
        }
    };


    return (
        <div className={isFullScreen ? 'sm_chat_body_con sm_full_screen' : 'sm_chat_body_con'}>
            <div className='sm_chat_body_header'>
                <div className='sm_chat_body_header_user_dp'>
                    {isFullScreen && <MdArrowBack className='sm_chat_body_header_back_icon' onClick={() => dispatch(chatActions.setOpenChat(false))} />}
                    <div className='sm_chat_body_header_user_dp_body'>
                        {(chat?.chatType == ChatType.PRIVATE && chatStatus?.isOnline) && <GoDotFill className='sm_chat_body_header_user_dp_online_icon' />}
                        {chat?.chatType == ChatType.PRIVATE && <img src={chat?.privateChatImage ? `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${chat.privateChatImage}` : defaultImg} alt="" />}
                        {chat?.chatType == ChatType.GROUP  && <img src={chat?.groupProfileImg ? `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${chat.groupProfileImg}` : defaultImg} alt="" />}
                    </div>
                    <div className='sm_chat_body_header_user_name'>
                        {chat?.chatType == ChatType.GROUP ?
                            <div className='sm_chat_body_header_group_info'>
                                <h3>{chat?.groupName}</h3>
                                <p>{memberNamesInShort?.join(", ")}</p>
                            </div>
                            : <>
                                <h3>{chat?.privateChatName}</h3>
                                {chatStatus?.isOnline && <h4>Online</h4>}
                                {!chatStatus?.isOnline && <h4>
                                    {chatStatus?.lastSeen ? `Last seen ${formatTimestamp(chatStatus?.lastSeen)}` : `New user`}</h4>
                                }
                            </>}
                    </div>
                </div>

            </div>
            <div className='sm_chat_body_content'>
                <div id="message_infine_scroll" className='sm_show_messages_list'>
                    <InfiniteScroll
                        scrollableTarget='message_infine_scroll'
                        next={fetchMoreMesssage}
                        inverse={true}
                        hasMore={hasMore}
                        style={{ display: 'flex', flexDirection: 'column-reverse', gap: '10px' }}
                        dataLength={allChatMessage.length}
                    >
                        {
                            allChatMessage?.map((cm, index) =>
                                <ChatMessageCard key={cm.chatMessageId}
                                    userInfo={userInfo}
                                    chat={chat}
                                    message={cm}
                                />
                            )
                        }
                    </InfiniteScroll>
                </div>

                <div className='sm_chat_text_input_box_con'>
                    <TextareaAutosize
                        onKeyDown={(e) => sendMessageOnEnterPress(e)}
                        value={message || ''}
                        onChange={(event) => setMessage(event.target.value)}
                        placeholder='Type your message here'
                        className='sm_chat_text_input_box_teaxtarea'
                    ></TextareaAutosize>
                    <IoMdSend onClick={chat.chatType == ChatType.GROUP ? sendGroupMessage : sendMessage} className='sm_chat_text_input_box_send_icon' />
                </div>
            </div>
            <div className='sm_add_new_chat_icon'>

            </div>
        </div>
    )
}

export default ChatBody